<template>
  <div  class="q-pa-md">
    <PageHeader content="送货单" />
    <el-row class="rightBtn">
      <div v-if="form.id">
        <el-button type="danger" @click="updateNote">修改</el-button>
        <el-button type="primary" @click="printNote">打印</el-button>
      </div>
      <div v-else>
        <el-button type="primary" @click="saveNote">创建</el-button>
      </div>
    </el-row>
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="送货单编号" prop="noteNo">
            <el-input v-model="form.noteNo">
              <el-button
                slot="append"
                icon="el-icon-edit"
                @click="getNoteNo"
                :disabled="disabled"
                >生成送货单编号</el-button
              >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <cust-selector ref="custSelector" />
        </el-col>
        <el-col :span="8">
          <el-form-item label="物流公司">
            <el-input v-model="form.expressCompany"> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="物流编号">
            <el-input v-model="form.expressNo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="送货日期" prop="deliveryDate">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="form.deliveryDate"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收货日期">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="form.receiveDate"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="物流费用">
            <el-input v-model="form.cost"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收件人">
            <el-input v-model="form.receiver"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="状态" prop="status">
            <el-select v-model="form.status" style="width: 100%" clearable>
              <el-option label="已发货" value="0"></el-option>
              <el-option label="已签收" value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="附件">
            <Upload ref="upload" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input
              type="textarea"
              v-model="form.remark"
              :autosize="{ minRows: 4, maxRows: 10 }"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item v-if="form.id" label="送货单明细">
        <el-row id="btnRow">
          <el-button
            @click="
              visible = true;
              dialogTitle = '添加送货单明细';
              deliveryItem.id = null;
              deliveryItem.noteNo = form.noteNo;
            "
            type="primary"
            id="addPlanBtn"
            >添加明细</el-button
          >
        </el-row>

        <el-table :data="itemList.list" style="width: 100%" border show-summary>
          <el-table-column prop="orderNo" label="订单编号"></el-table-column>
          <el-table-column label="纱支原料" prop="yarn"></el-table-column>
          <el-table-column label="颜色/色号">
            <template slot-scope="scope">
              <span>{{ scope.row.color }} {{ scope.row.colorNo }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="投染数"
            prop="productWeight"
          ></el-table-column>
          <el-table-column label="净重" prop="netWeight"></el-table-column>
          <el-table-column prop="cylNo" label="缸号"></el-table-column>
          <el-table-column prop="packages" label="件数"></el-table-column>
          <el-table-column prop="price" label="单价"></el-table-column>
          <el-table-column prop="status" label="状态"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>

    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="visible"
      :width="dialogWidth"
    >
      <el-form ref="deliveryItem" :model="deliveryItem" label-width="100px">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="订单编号">
              <el-input v-model="deliveryItem.orderNo">
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="showInnerDialog"
                ></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目编号">
              <el-input v-model="deliveryItem.itemNo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="纱支">
              <el-input v-model="deliveryItem.yarn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="颜色">
              <el-input v-model="deliveryItem.color"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="色号">
              <el-input v-model="deliveryItem.colorNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="投染数(KG)">
              <el-input
                type="number"
                v-model="deliveryItem.productWeight"
                step="0.01"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="净重(KG)">
              <el-input
                type="number"
                v-model="deliveryItem.netWeight"
                step="0.01"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单价(元/KG)">
              <el-input
                type="number"
                v-model="deliveryItem.price"
                step="0.1"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="件数">
              <el-input
                type="number"
                v-model="deliveryItem.packages"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="加工">
              <el-input v-model="deliveryItem.process"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="缸号">
              <el-input v-model="deliveryItem.cylNo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="deliveryItem.remark"
            :autosize="{ minRows: 4, maxRows: 10 }"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="saveItem">保 存</el-button>
      </div>

      <el-dialog
        width="80%"
        title="选择项目"
        :visible.sync="innerVisible"
        append-to-body
      >
        <el-form id="queryForm" :model="queryForm" label-width="100px">
          <el-row :gutter="30">
            <el-col :span="6">
              <el-form-item label="订单编号">
                <el-input v-model="queryForm.orderNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="缸号">
                <el-input v-model="queryForm.cylinderNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="订单开始日期">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="queryForm.beginTime"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="订单结束日期">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="queryForm.endTime"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="18">
              <el-form-item>
                <el-button type="primary" @click="reset">重置</el-button>
                <el-button
                  type="primary"
                  @click="
                    queryForm.pageNum = 1;
                    queryForm.pageSize = 10;
                    queryPlan();
                  "
                  >查询</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <el-table
          :data="planTable.list"
          style="width: 100%"
          highlight-current-row
          :default-sort="{ prop: 'customer', order: 'descending' }"
        >
          <el-table-column prop="orderNo" label="订单编号"></el-table-column>
          <el-table-column prop="cylinderNo" label="缸号"></el-table-column>
          <el-table-column label="纱支原料" prop="yarn"></el-table-column>
          <el-table-column label="颜色/色号">
            <template slot-scope="scope">
              <span>{{ scope.row.color }}/{{ scope.row.colorNo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="投染数/净重(KG)">
            <template slot-scope="scope">
              <span
                >{{ scope.row.productWeight }}/{{ scope.row.netWeight }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="单价"
            prop="orderItems.unitPrice"
          ></el-table-column>
          <el-table-column label="加工" prop="process"></el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="selectItem(scope.$index, scope.row)"
                >选择</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="queryPlan"
          @size-change="queryPlan"
          :current-page.sync="queryForm.pageNum"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 30, 40, 50]"
          :total="planTable.total"
          layout="total,sizes, prev, pager, next"
        ></el-pagination>
        <div slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false">取 消</el-button>
          <el-button type="primary" @click="selectItem">确 定</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import Upload from "@/components/Upload.vue";
import CustSelector from "../components/CustSelector.vue";
export default {
  components: {
    PageHeader,
    Upload,
    CustSelector,
  },
  data() {
    return {
      form: { noteNo: "", customerNo: "", id: null },
      itemList: [],
      disabled: false,
      dialogWidth: "800px",
      visible: false,
      innerVisible: false,
      deliveryItem: {},
      queryForm: { pageNum: 1, pageSize: 10 },
      planTable: {},
      dialogTitle: "",
      rules: {
        noteNo: [
          { required: true, message: "送货单编号不能为空", trigger: "change" },
        ],
        deliveryDate: [
          { required: true, message: "送货日期不能为空", trigger: "change" },
        ],
        status: [
          { required: true, message: "状态不能为空", trigger: "change" },
        ],
        customerNo: [
          { required: true, message: "客户不能为空", trigger: "change" },
        ],
      },
    };
  },
  created() {
    if (this.$route.params.id) {
      this.getNote(this.$route.params.id);
    } else {
      this.getNoteNo();
    }
  },
  methods: {
    getNoteNo() {
      var self = this;
      this.$axios.get("/delivery/getNoteNo").then(function (response) {
        if (response.data.errorCode == "00000") {
          self.form.noteNo = response.data.data;
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    getNote(id) {
      var self = this;
      this.$axios.get("/delivery/" + id).then(function (response) {
        if (response.data.errorCode == "00000") {
          self.form = response.data.data;
          self.disabled = true;
          self.$refs.custSelector.customerNo = self.form.customerNo;
          if (self.form.attachment) {
            self.$refs.upload.fileList = JSON.parse(self.form.attachment);
          }
          //查询项目明细
          self.getItemList(self.form.noteNo);
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    getItemList(noteNo) {
      var self = this;
      var params = { noteNo: noteNo };
      this.$axios
        .get("/delivery/item/list", { params: params })
        .then(function (response) {
          if (response.data.errorCode == "00000") {
            self.itemList = response.data.data;
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    saveNote() {
      console.info("创建送货单");
      var self = this;
      this.form.customerNo = this.$refs.custSelector.customerNo;
      this.form.attachment = JSON.stringify(this.$refs.upload.fileList);
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/delivery/save", self.form)
            .then(function (response) {
              if (response.data.errorCode == "00000") {
                self.$message({
                  message: "创建成功",
                  type: "success",
                });
                self.$router.push("/delivery/detail/" + response.data.data);
              } else {
                self.$message.error(response.data.errorMsg);
              }
            });
        }
      });
    },
    updateNote() {
      var self = this;
      this.form.customerNo = this.$refs.custSelector.customerNo;
      this.form.attachment = JSON.stringify(this.$refs.upload.fileList);
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/delivery/update", self.form)
            .then(function (response) {
              if (response.data.errorCode == "00000") {
                self.$message({
                  message: "修改成功",
                  type: "success",
                });
              } else {
                self.$message.error(response.data.errorMsg);
              }
            });
        }
      });
    },
    saveItem() {
      console.info("123");
      var self = this;
      if (self.deliveryItem.id) {
        this.$axios
          .post("/delivery/item/update", self.deliveryItem)
          .then(function (response) {
            if (response.data.errorCode == "00000") {
              self.$message({
                message: "更新成功",
                type: "success",
              });
              //查询项目明细
              self.getItemList(self.form.noteNo);
              self.visible = false;
            } else {
              self.$message.error(response.data.errorMsg);
            }
          });
      } else {
        this.$axios
          .post("/delivery/item/save", self.deliveryItem)
          .then(function (response) {
            if (response.data.errorCode == "00000") {
              self.$message({
                message: "创建成功",
                type: "success",
              });
              //查询项目明细
              self.getItemList(self.form.noteNo);
              self.visible = false;
            } else {
              self.$message.error(response.data.errorMsg);
            }
          });
      }
    },
    showInnerDialog() {
      this.innerVisible = true;
      this.queryPlan();
    },
    queryPlan() {
      console.info("查询计划");
      this.queryForm["customer.customerNo"] = this.form.customerNo;
      var self = this;
      this.$axios
        .get("/orderPlan/queryDelivery", { params: self.queryForm })
        .then(function (response) {
          if (response.data.errorCode == "00000") {
            self.planTable = response.data.data;
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    reset() {
      this.queryForm = {};
      this.queryPlan();
    },
    selectItem(index, row) {
      console.info("选择项目" + index + row);
      this.deliveryItem = {
        noteNo: this.form.noteNo,
        orderNo: row.orderNo,
        itemNo: row.itemNo,
        yarn: row.yarn,
        color: row.color,
        colorNo: row.colorNo,
        productWeight: row.productWeight,
        netWeight: row.netWeight,
        price: row.orderItems.unitPrice,
        process: row.process,
        cylNo: row.cylinderNo,
      };
      //隐藏嵌套对话框
      this.innerVisible = false;
    },
    handleEdit(index, row) {
      this.dialogTitle = "修改送货单明细";
      this.visible = true;
      this.deliveryItem = JSON.parse(JSON.stringify(row));
    },
    printNote() {
      console.log("打印");
    },
  },
};
</script>

<style scoped>
.el-form {
  margin-top: 35px;
}
#btnRow {
  margin-bottom: 15px;
}
.rightBtn {
  float: right;
  margin-top: -25px;
}
</style>